
    import './styles.scoped.css';
    export default {
  "custom-range": "awsui_custom-range_16zmw_1aor8_9",
  "custom-range--no-padding": "awsui_custom-range--no-padding_16zmw_1aor8_15",
  "custom-range-form-controls": "awsui_custom-range-form-controls_16zmw_1aor8_19",
  "custom-range-duration": "awsui_custom-range-duration_16zmw_1aor8_23",
  "custom-range-unit": "awsui_custom-range-unit_16zmw_1aor8_24",
  "vertical": "awsui_vertical_16zmw_1aor8_30"
};
  